<template>
  <div>

    <!-- <b-button class="float-left mx-2 " pill variant="dark" v-b-modal.chooseEvaluationMethod>Choose evaluation
      options
    </b-button>

    <b-button @click="$root.clearSubContent" class="float-right mx-2 " variant="light"><i
        class="fas fa-window-close fa-1x text-danger"></i>
    </b-button> -->

    <div class="loading" v-if="fetchData">
      <load-data></load-data>
    </div>
    <div v-else class="typeOfExam">
      <b-tabs content-class="mt-3" justified v-model="tabIndex" pills lazy>
        <b-tab v-for="(tab, optionIndex) in tabs" :key="optionIndex" :title="tab.text">
          <component v-bind:is="tab.component" :enableTaxonomy="enableTaxonomy" :enableCo="enableCo"
            :enableOrQuestion="enableOrQuestion" :enableModule="enableModule" :exam_id="exam_id" />
        </b-tab>
      </b-tabs>
    </div>

    <!-- <b-modal id="chooseEvaluationMethod" v-model="modalShow" hide-footer title="Evaluation options" no-close-on-backdrop
      no-close-on-keyboard no-close-on-esc>
      <div>
        <b-form-group label="I want to update" v-slot="{ ariaDescribedby }">
          <b-form-radio @change="updateTabView()" v-model="selectedType" :aria-describedby="ariaDescribedby"
            name="some-radios" value="offline">
            Question score for each student with CO mapping</b-form-radio>
          <b-form-radio @change="updateTabView()" v-model="selectedType" :aria-describedby="ariaDescribedby"
            name="some-radios" value="coScore">CO
            wise score for each student</b-form-radio>
        </b-form-group>
      </div>
    </b-modal> -->

  </div>
</template>

<script>
// import OnlineExam from "./OnlineExam.vue";
import OfflineExam from "./OfflineExam.vue";
// import McqEvaluation from "./McqEvaluation.vue";
import ParticipantsCourseoutcomesScore from "./ParticipantsCourseoutcomesScore.vue";

export default {
  props: ['exam_id'],
  async created() {
    this.fetchData = true;
    await this.getExam();
    if (this.exam.co_score_evaluation == 1) {
      this.tabs.push({ text: "Participants vs CO's Score", component: "ParticipantsCourseoutcomesScore" });
    } else {
      const title = this.exam.co_score_evaluation == 2 ? "Total mark entry" : "Question CO mapping & score";
      this.tabs.push({ text: `${this.exam.name} :${title}`, component: "OfflineExam" });
    }
    // else {
    //   this.modalShow = true;
    // }
    this.fetchData = false;
  },
  components: {
    // OnlineExam,
    OfflineExam,
    ParticipantsCourseoutcomesScore,
    // McqEvaluation,
  },
  data() {
    return {
      fetchData: false,
      tabIndex: 0,
      tabs: [],
      // selectedType: '',
      // modalShow: false,
      enableCo: true,
      enableTaxonomy: true,
      enableModule: true,
      enableOrQuestion: true,
      exam: {}
    };
  },
  methods: {
    // updateTabView() {
    //   this.tabs = [];
    //   if (this.selectedType == 'offline') {
    //     this.tabs.push({ text: "Question CO mapping & score", component: "OfflineExam" });
    //   } else if (this.selectedType == 'coScore') {
    //     this.tabs.push({ text: "Participants vs CO's Score", component: "ParticipantsCourseoutcomesScore" });
    //   }
    //   this.modalShow = false;
    // },
    async getExam() {
      var examId = this.$route.params.exam_id;
      if (!examId) examId = this.exam_id;
      const url = this.$store.getters.getAPIKey.examination + `/${examId}`;
      await this.$axios
        .get(url)
        .then((response) => {
          this.exam = response.data;
        })
        .catch((error) => {
          error;
        });
    },
  },
};
</script>

<style >
.typeofexam .nav-tabs .nav-link {
  font-size: 14px !important;
  font-weight: 600 !important;
}
</style>
